import BaseCascader from './BaseCascader';
import { buildAreaTree } from './utils';

/**
 * AreaCascader — 省市区县级联组件
 *
 * 继承 BaseCascader，复用取数、缓存、渲染逻辑，
 * 仅重写转换方法以支持按 data_source 裁剪层级：
 *   province              → 只显示省（1级）
 *   province_city         → 显示省市（2级）
 *   province_city_district→ 显示省市区县（3级）
 *
 * 同时重写 handleChange，增加必须选到最后一级的校验
 */

// 省市区县各类型对应的必选层级
const REQUIRED_LEVEL_MAP = {
    province: 1,
    province_city: 2,
    province_city_district: 3
};

const AreaCascader = (props) => {
    const { form, en_name, setting } = props;
    const dataSource = setting.data_source;

    /** 重写转换方法：使用省市区县专用构建逻辑，按类型裁剪层级 */
    const convertToTree = (rawData) => {
        const requiredLevel = REQUIRED_LEVEL_MAP[dataSource] || 3;
        return buildAreaTree(rawData, requiredLevel);
    };

    /** 重写 change 方法：增加必须选到指定层级的校验 */
    const handleChange = (value, selectedOptions) => {
        const requiredLevel = REQUIRED_LEVEL_MAP[dataSource];
        if (requiredLevel && value?.length < requiredLevel) {
            // 选择了非最后一级，阻止选择
            return false;
        }
        const nameArray = selectedOptions?.map((option) => option.label);
        form?.setFieldsValue({ [`${en_name}_name`]: nameArray });
    };

    // 渲染 BaseCascader，注入自定义的转换和 change 方法
    // 通过 render props / 组合方式实现"继承"
    return (
        <BaseCascader
            {...props}
            customConvertToTree={convertToTree}
            customHandleChange={handleChange}
        />
    );
};

export default AreaCascader;
